<template>
  <v-app id="getBcmsAll">
    <v-main>
     <v-container fluid>
       <v-row no-gutters>
        <v-card class="px-2">
            <v-text-field
            v-model="search"
              label="Search"
              single-line
              hide-details
             >
            </v-text-field>
        
            <v-data-table 
            :items="items" 
            :items-per-page="50" 
            :footer-props="{'items-per-page-options': [50, 100, 200, 300, 500]}"
            :headers="headers"
            :search="search"        
            >
            <template v-slot:item="props">
              <tr>
              <td @click="$router.open('/task/guestMessages/bcms/onBcms/' + props.item.bcms_encrid)"><a> {{props.item.bcms_dt}} </a></td>
              <td><v-chip :color=props.item.bcms_status_kleur>{{props.item.bcms_status}}</v-chip></td>
              
              </tr>
            </template>
            </v-data-table>
        </v-card>
        </v-row>
     </v-container>
    </v-main>
    <navBar title="Ares - Guest messages" :home="true" type="guestmessages"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";

 export default {
  components: {
    navBar,
  },
  data() {
    return {
      items: [],
      search: '',
      headers: [
        {text: 'Date/Time', value: 'bcms_dt'},
        {text: 'Status', value: 'bcms_status'},
      ]
    }  
  },
  mounted() {
      this.results = true;
      this.$axios
        .post("ares/json/ares/task/guestMessages/bcms/getBcmsAll.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getBcmsAll"
          },
          getBcmsAll: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.getBcmsAll;
          }
        })
        .finally(() => {
          this.loading = false;
        });
  }
};

</script> 
